import { useSelector } from "react-redux";
import isEqual from "lodash/isEqual";

import { INSTAGRAM } from "constants/channelConstants";

const useIsActiveConversationInsta = () => {
  const activeConversation = useSelector(
    (state) => state.thread.activeConversation,
    isEqual,
  );

  return activeConversation?.channel_type === INSTAGRAM;
};

export default useIsActiveConversationInsta;
